import { ArrowUpRight, Check } from 'lucide-react';
import { Eyebrow, Reveal } from './Reveal';

const PLATFORMS = [
  {
    testid: 'platform-card-talent-network',
    tag: 'COMING SOON / CANDIDATE PLATFORM',
    name: 'Sania Talent Network',
    tagline: 'Your career. Your opportunities.',
    desc: 'A planned candidate-focused platform for professional profiles, relevant job discovery, applications and recruitment updates.',
    features: [
      'Candidate profiles and skills',
      'Job search and applications',
      'Availability and joining preferences',
      'Application and recruitment updates',
    ],
    cta: 'Enquire about launch updates',
    mailto: 'mailto:connect@saniajobbowl.com?subject=Sania%20Talent%20Network%20Updates',
    ctaTestid: 'platform-cta-talent-network',
  },
  {
    testid: 'platform-card-campus-network',
    tag: 'COMING SOON / STUDENT & CAMPUS PLATFORM',
    name: 'Sania Campus Network',
    tagline: 'Connecting campuses to careers.',
    desc: 'A planned platform linking students, educational institutions and employers for campus sourcing, internships and early-career opportunities.',
    features: [
      'Student and college profiles',
      'Course and education information',
      'Part-time, weekend and full-time availability',
      'Campus hiring and internship opportunities',
    ],
    cta: 'Enquire about campus partnerships',
    mailto: 'mailto:connect@saniajobbowl.com?subject=Sania%20Campus%20Network%20Updates',
    ctaTestid: 'platform-cta-campus-network',
  },
];

export default function Platforms() {
  return (
    <section id="digital-platforms" data-testid="platforms-section" className="grain-dark relative scroll-mt-28 overflow-hidden bg-royal-ink py-20 lg:py-28">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-32 top-10 h-96 w-96 rounded-full bg-royal/50 blur-3xl" />
        <div className="absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-lime/10 blur-3xl" />
        <span className="absolute left-6 top-8 hidden font-display text-[160px] font-extrabold leading-none text-outline-light lg:block">
          04
        </span>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow light index="06">
              Upcoming Apps
            </Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.12]">
              Coming soon · Sania digital ecosystem
            </h2>
            <p className="mt-3 font-display text-lg font-bold text-lime sm:text-xl">
              Two platforms. More ways to connect talent with opportunity.
            </p>
            <p className="mt-5 text-base leading-relaxed text-white/65">
              Beyond our workforce services, Sania Job Bowl is developing dedicated digital experiences for job
              seekers, students, colleges and employers. These platforms are in development and are not yet available
              for public registration.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
          {PLATFORMS.map((p, i) => (
            <Reveal key={p.testid} delay={i * 0.12} className="h-full">
              <article
                data-testid={p.testid}
                className="group flex h-full flex-col rounded-[1.75rem] border border-white/15 bg-white/[0.06] p-8 backdrop-blur-md transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1.5 hover:border-lime/50 hover:bg-white/[0.09] sm:p-10"
              >
                <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.26em] text-lime">{p.tag}</p>
                <h3 className="mt-4 font-display text-2xl font-extrabold text-white sm:text-3xl">{p.name}</h3>
                <p className="mt-2 font-display text-base font-bold italic text-white/80">{p.tagline}</p>
                <p className="mt-4 text-sm leading-relaxed text-white/60">{p.desc}</p>
                <ul className="mt-6 space-y-3">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-white/80">
                      <span className="mt-0.5 inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-lime/20 text-lime">
                        <Check className="h-2.5 w-2.5" strokeWidth={3.2} aria-hidden="true" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto pt-8">
                  <a
                    href={p.mailto}
                    data-testid={p.ctaTestid}
                    className="group/cta inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 font-display text-[13px] font-bold uppercase tracking-[0.14em] text-white transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 hover:border-lime hover:bg-lime hover:text-royal-ink"
                  >
                    {p.cta}
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/cta:translate-x-0.5 group-hover/cta:-translate-y-0.5" aria-hidden="true" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-xs leading-relaxed text-white/45">
            Illustrative feature roadmap. Final features and launch dates will be announced when confirmed.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
